<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" v-model="actionData.model.selectedAll"
                  @change="changeSelectAll()" id="selectedAll" />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button type="button" class="dropdown-toggle dropdown-toggle-split btn" data-toggle="dropdown"
            aria-expanded="false" aria-haspopup="true"></button>
          <div class="dropdown-menu">
            <button :disabled="actionData.model.listSelected.length === 0" class="dropdown-item"
              @click="setupSelectOneAction('action_list', null, null)" color="danger">
              <i class="fa fa-stop-circle mr-2" style="font-size: 1.1rem!important;"></i>
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <CCol sm="3" md="3" xl="2" xs="12">
        <BaseInput :options="nameInput.options" :data="nameInput.data" />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary" @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton style="float: right;margin-left: 5px;" color="primary" v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary" @click="clickAdd()">
              <i class="fa fa-plus"></i>&nbsp;Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
          @row-click="rowClickTable($event)" ref="mainTable">
          <template #checkbox="{ item }">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" v-model="actionData.model.listSelected"
                  :value="item.id" :id="item.id" />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYY(item.createDate) }}
            </td>
          </template>
          <template #action="{ item, index }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton color="info" variant="outline" v-c-tooltip.hover="'Cập nhật'" square size="sm"
                  @click="setupUpdate(item.id)">
                  <CIcon name="cil-pencil" />
                </CButton>
                <CButton color="danger" variant="outline" class="ml-1" square size="sm" v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash" />
                </CButton>
              </div>
            </td>
          </template>

        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal :title="dataSave.id ? 'Cập nhật Version' : 'Thêm mới Version'" :show.sync="isShowModal" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput :options="dataSave.nameInput.options" :data="dataSave.nameInput.data" />
        </CCol>
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput :options="dataSave.urlInput.options" :data="dataSave.urlInput.data" />
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitData()">
          <i class="fa" :class="dataSave.id ? 'fa-save' : 'fa-save'"></i> {{ dataSave.id ? 'Lưu lại' : 'Lưu lại' }}
        </button>
      </template>
      <BaseLoading :loading="loading.value"></BaseLoading>
    </CModal>

    <BaseFormLoading :value="loading.value"></BaseFormLoading>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import { DatePicker } from "v-calendar";
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2"
import BaseTextArea from "@/views/base/BaseTextArea";
import BaseLoading from "@/views/base/BaseFormLoading";
import BaseFormLoading from "@/views/base/BaseFormLoading";

export default {
  name: "PhoneSimManageList",
  components: {
    BaseFormLoading,
    BaseLoading,
    BaseTextArea,
    DatePicker,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {

    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/version-fw/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "số Version",
          that.actionData.model.textNotifi
        )
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.id,
        }
      },
      successCallback: function () {
        that.showSuccessMsg({ message: "Xóa Version " + that.actionData.model.textNotifi + " thành công" });
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("action_list", {
      url: "/version-fw/deleteList",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "các Version", "đã chọn");
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          ids: that.actionData.model.listSelected,
        };
      },
      successCallback: function () {
        that.actionData.model.listSelected = [];
        that.showSuccessMsg({ message: "Xóa các Version thành công" });
        that.loadDataMainTable();
      },
    });

    let that = this;
    return {
      loading: { value: false },
      isShowModal: false,
      collapseDuration: 0,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          id: null,
          textNotifi: null,
          listSelected: [],
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên Version",
          label: 'Tên Version'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            { key: "checkbox", label: "#" },
            { key: "createDate", label: "Ngày tạo" },
            { key: "name", label: "Tên Version" },
            { key: "url", label: "URL" },
            { key: "action", label: "Thao tác", sorter: false, filter: false },
          ],
          slots: ["checkbox", "index", "createDate", "action"],
          pageSize: 20,
          sorter: true,
          // hover: false,
          columnFilter: false,
          clickableRows: true,
          itemsPerPageSelect: { label: ' ', values: [15, 20, 30, 50, 100], external: true },
          tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
        },
        dataSource: {
          url: "/version-fw/getPages",
          dataSubmit: function () {
            return {
              name: that.nameInput.data.model || null,
            }
          },
          response: function (dataResponse) {
            that.actionData.model.listSelected = [];
            return dataResponse.data;
          }
        }
      },

      dataSave: {
        id: null,
        nameInput: {
          options: {
            label: "Tên version <span class='required'>*</span>",
            placeholder: "Tên version",
            type: "text",
          },
          data: {
            name: "name",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.nameInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Tên Version không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
        urlInput: {
          options: {
            label: "URL <span class='required'>*</span>",
            placeholder: "URL version",
            type: "text",
          },
          data: {
            name: "url",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.urlInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "URL version không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          }
        },
      },
    };
  },
  methods: {
    changeSelectAll: function () {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listSelected = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listSelected.push(each.id);
        });
      } else {
        this.actionData.model.listSelected = [];
      }
    },
    rowClickTable(value) {
      let targetClick = value.event.target;
      // if (value.column === 'volume' && ($(targetClick).is("button") || $(targetClick).is("span") || $(targetClick).is("i"))) {
      //   return;
      // } else
      if (value.column === 'details' || value.column === 'action' && ($(targetClick).is("i.fa")) ||
        $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
        return;
      }
      if (value && value.item && value.item.id) {
        if (this.actionData.model.listSelected.includes(value.item.id)) {
          const index = this.actionData.model.listSelected.indexOf(value.item.id)
          if (index > -1) {
            this.actionData.model.listSelected.splice(index, 1);
            value.item._classes = 'inactive';
          }
        } else {
          value.item._classes = 'active';
          this.actionData.model.listSelected.push(value.item.id);
        }
      }
    },
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.items.map(each => delete each._classes);
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    setupSelectOneAction: function (actionTypeKey, id, textNotifi) {
      let actionData = this.actionData.model;
      actionData.id = id;
      actionData.textNotifi = textNotifi;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    clickAdd() {
      this.isShowModal = true;
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.dataSave.urlInput.data.validator.valid();
      isValid &= this.dataSave.nameInput.data.validator.valid();
      if (!isValid) {
        return;
      }

      that.loading.value = true;

      that.$helper.loadDataSource({
        url: that.dataSave.id ? "/version-fw/update" : "/version-fw/create",
        dataSubmit: function () {
          return {
            id: that.dataSave.id,
            name: that.dataSave.nameInput.data.model,
            url: that.dataSave.urlInput.data.model
          };
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({ message: !that.dataSave.id ? "Thêm mới Version thành công" : "Cập nhật Version thành công" });
          }
          that.isShowModal = false;
          that.loading.value = false;
          that.loadDataMainTable();
          that.clearDataSave();
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    clearDataSave() {
      this.dataSave.urlInput.data.model = '';
      this.dataSave.urlInput.data.validator.isValid = true;
      this.dataSave.nameInput.data.model = '';
      this.dataSave.nameInput.data.validator.isValid = true;
      this.dataSave.id = null;;
    },
    setupUpdate(_id) {
      let that = this;
      that.dataSave.id = _id;
      that.$helper.loadDataSource({
        url: "/version-fw/findById",
        dataSubmit: function () {
          return {
            id: _id
          };
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.$helper.setupDataResponse(that.$data.dataSave, response.data.data);
            that.isShowModal = true;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listSelected": function (newValue) {
      let that = this;
      if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
        that.$refs.mainTable.items.map(each => each._classes = 'active');
      } else {
        that.actionData.model.selectedAll = false;
        if (newValue.length == 0) {
          that.$refs.mainTable.items.map(each => each._classes = 'inactive');
        }
      }
    },
    "actionData.model.listPhoneNumberDetailSelectedId": function (newValue) {
      let that = this;
      if (that.mainTable.items.length > 0 && newValue.length === that.mainTable.items.length) {
        that.actionData.model.selectedAllPhoneDetail = true;
        that.mainTable.items.map(each => each._classes = 'active');
      } else {
        that.actionData.model.selectedAllPhoneDetail = false;
        if (newValue.length == 0) {
          that.mainTable.items.map(each => each._classes = 'inactive');
        }
      }
    },
    isShowModal(value){
      if(!value){
        this.clearDataSave();
      }
    }
  },
  computed: {}
};
</script>
<style scoped></style>
